import { IDecodedToken, PaymentPlanStatus, RequisitionStatus } from '@inshuwa-client/models';
import { isAirtel } from "./insurer.utils";
import { JwtHelperService } from "@auth0/angular-jwt";

// Icon mapping for class of business
export const CLASS_ICONS: { [key: string]: string } = {
  motor: isAirtel() ? '../../../assets/motor_insurance_logo.png' : 'car',
  life: isAirtel()
    ? '../../../assets/health_and_life_insurance_logo.png'
    : 'heart',
  travel: isAirtel()
    ? '../../../assets/local_travel_insurance_logo.png'
    : 'global',
  general: isAirtel()
    ? '../../../assets/general_insurance_logo.png'
    : 'appstore',
  fire: 'fire',
  accident: 'warning',
  marine: 'compass',
  engineering: 'tool',
  liability: 'safety',
  microinsurance: 'team',
  'bonds and guaranties': 'file-protect',
  global: isAirtel()
    ? '../../../assets/local_travel_insurance_logo.png'
    : 'global',
  car: isAirtel() ? '../../../assets/motor_insurance_logo.png' : 'car',
};

export const transactionStatusColor = (status: string ) => {
  switch (status.toLowerCase()) {
    case 'success':
      return 'success';
    case 'pending':
      return 'yellow';
    case 'failed':
      return 'error';
    case 'cancelled':
      return 'default';
    case 'reversed':
      return 'warning';
    case 'refunded':
      return 'magenta';
    default:
      return 'default';
  }
}

type Token = Record<string, any>;
export const JWTDecoder = (token: string) => {
  const decodedToken = new JwtHelperService().decodeToken(
    token,
  )! as Token;
  return decodedToken as IDecodedToken;
}

export const getStatusColor = (status: string) => {
  switch (status) {
    case PaymentPlanStatus.Active:
      return 'blue';
    case PaymentPlanStatus.FullyPaid:
      return 'green';
    case PaymentPlanStatus.PartiallyPaid:
      return 'orange';
    case PaymentPlanStatus.Pending:
      return 'gold';
    case PaymentPlanStatus.Cancelled:
      return 'red';
    case PaymentPlanStatus.Suspended:
      return 'volcano';
    default:
      return 'default';
  }
}

export const getRequisitionStatusColor = (status: RequisitionStatus | string) => {
  switch (status) {
    case 'Created':
    case 'Pending':
    case 'PendingApproval':
      return 'gold';
    case 'Approved':
    case 'AwaitingSettlement':
    case 'Revised':
      return 'blue';
    case 'PaymentProcessing':
      return 'cyan';
    case 'Settled':
      return 'green';
    case 'Rejected':
      return 'red';
    case 'SettlementFailed':
      return 'volcano';
    default:
      return 'default';
  }
}

export const getQuotationStatusColor = (status: string) => {
  switch (status) {
    case 'Approved':
      return 'green';
    case 'Counter':
      return 'blue';
    case 'Pending':
      return 'yellow';
    case 'Complete':
      return '#10b981';
    case 'Expired':
      return 'gray';
    case 'Rejected':
      return 'red';
    case 'Issued':
      return 'indigo';
    case 'Placed':
      return 'cyan';
    case 'Accepted':
      return 'purple';
    default:
      return 'default';
  }
}
